import { mapGetters, mapState } from 'vuex'

export default {
	computed: {
		...mapState({
			subscription: 'subscription',
			main_user_id: 'main_user_id',
			user: 'user'
		}),
		...mapGetters({
			language: 'i18n/getLanguage',
			domain: 'location/domain',
			getQueryParam: 'location/getQueryParam',
			isReferral: 'location/isReferral',
			manageSubscriptionSource: 'location/manageSubscriptionSource',
			getPropertyValue: 'survey/getPropertyValue',
			countryCode: 'getCountryCode',
			gdpr: 'getGdprStatus'
		}),
		IS_APPLY_TAX_TO_PRODUCTS_ENABLED() {
			return false
		},
		IS_BULK_EXP() {
			return !this.domain.SIMPLEAPP
		},
		IS_MALE_FUNNEL_PHYSICAL_PART_EXP() {
			return this.$absmartly.treatment('web_male_funnel_physical_part')
		},
		IS_REVAMPED_COPY_EXP() {
			return this.$absmartly.treatment('web_revamped_copy')
		},
		IS_CHAT_GPT_REVIEWS_EXP() {
			return ['en', 'de', 'fr'].includes(this.language) && this.$absmartly.treatment('web_bionicle_customer_reviews')
		},
		IS_PALTA_PAYMENTS_EXP() {
			return this.$absmartly.treatment('web_palta_payments') || this.$absmartly.treatment('web_palta_payments_us')
		},
		IS_ML_CHURN_FREE_TRIAL_EXP() {
			return this.$absmartly.treatment('web_ml_churn_predict_free_trial')
		},
		IS_ML_CHURN_AA_EXP() {
			return this.$absmartly.treatment('web_ml_churn_aa')
		},
		IS_PERSONALIZED_UPSELLS_EXP() {
			return this.$absmartly.treatment('web_personalized_upsells')
		},
		IS_WEIGHT_PREDICT_NEW_GRAPHS_EXP() {
			return this.IS_MAIN_FUNNEL || this.IS_MALE_FUNNEL || this.IS_FEMALE_FUNNEL
		},
		IS_GENDER_SELECTION_OR_EMAIL_BEFORE_PREDICT_EXP() {
			return this.IS_MAIN_FUNNEL
		},
		IS_MALE_FUNNEL_EMAIL_BEFORE_PREDICT_EXP() {
			return this.countryCode === 'us' && this.IS_MALE_FUNNEL
		},
		IS_FEMALE_FUNNEL_EMAIL_BEFORE_PREDICT_EXP() {
			return this.$absmartly.treatment('web_female_funnel_email_before_predict')
		},
		IS_OPTIMIZED_FEMALE_FUNNEL_EXP() {
			return this.$absmartly.treatment('web_female_funnel_optimization')
		},
		IS_CHEAP_AND_SHORT_SCENARIO() {
			if (this.IS_LEGACY_RETARGETING || this.isReferral || this.$absmartly.treatment('web_old_paywall_vs_3_plans')) {
				return false
			}

			return true
		},
		IS_CHEAP_OFFER_POPUP_EXP() {
			return [
				this.$absmartly.treatment('web_cheap_offer_popup'),
				this.$absmartly.treatment('web_female_cheap_offer_popup'),
				this.$absmartly.treatment('web_male_cheap_offer_popup')
			].some(Boolean)
		},
		IS_MEAL_PLAN_SUBSCRIPTION_EXP() {
			if (this.subscription?.store === 'palta') {
				return false
			}

			return this.$absmartly.treatment('web_meal_plan_subscription')
		},
		IS_REFERRAL_SCREEN_EXP() {
			if (typeof window.navigator.share !== 'function') {
				return false
			}

			return this.$absmartly.treatment('web_referral_screen')
		},
		IS_EXTERNAL_SIMPLE_BILLING_EXP() {
			return this.$absmartly.treatment('web_external_billing')
		},
		IS_KOTO_WEB_ACTIVATION_CHATBOT_EXP() {
			return this.$absmartly.treatment('web_koto_web_activation_chatbot')
		},
		IS_REMOVING_AUTO_LOGIN_EXP() {
			return this.$absmartly.treatment('web_removing_auto_login')
		},
		IS_SCIENCE_BUNDLE_FIX_EXP() {
			return this.$absmartly.treatment('web_science_bundle_fix')
		},
		IS_REFERRAL_BONUS_RETARGETING() {
			return this.getQueryParam('plan') === 'REFERRAL_BONUS'
		},
		IS_LEGACY_RETARGETING() {
			return this.getQueryParam('plan') === '3MONTH'
		},
		IS_MALE_SCIENCE_BUNDLE_FIX_EXP() {
			return this.$absmartly.treatment('web_male_science_bundle_fix')
		},
		IS_LEGAL_TRE_CR_FIX_EXP() {
			return [
				this.$absmartly.treatment('web_legal_tre_cr_fix'),
				this.$absmartly.treatment('web_female_legal_tre_cr_fix'),
				this.$absmartly.treatment('web_male_legal_tre_cr_fix')
			].some(Boolean)
		},
		IS_VAT_ADAPTATION_FOR_SHORT_PLANS_EXP() {
			return this.$absmartly.treatment('web_vat_adaptation_for_short_plans')
		},
		IS_MALE_FUNNEL_WITHOUT_PREDICT_EXP() {
			return this.$absmartly.treatment('web_male_funnel_without_predict')
		},
		IS_FEMALE_FUNNEL_LIGHT_THEME_EXP() {
			return this.IS_FEMALE_FUNNEL
		},
		IS_UPSELL_ZING_BODY_SCAN_EXP() {
			return [
				this.$absmartly.treatment('web_upsell_zing_body_scan'),
				this.$absmartly.treatment('web_upsell_zing_body_scan_rollout'),
				this.$absmartly.treatment('web_female_upsell_zing_body_scan'),
				this.$absmartly.treatment('web_male_upsell_zing_body_scan')
			].some(Boolean)
		},
		IS_ASSESSMENT_WORKBOOKS_EXP() {
			// We don't want to show this experiment for already existing users
			// Because we need to set this flag for old user in this case
			if (this.user.id !== this.main_user_id) {
				return false
			}

			// FIXME
			return this.$absmartly.treatment('web_assessment_workbooks')
		},
		IS_NEW_COPY_3_PLANS_EXP() {
			return [
				this.$absmartly.treatment('web_new_copy_3_plans'),
				this.$absmartly.treatment('web_female_new_copy_3_plans'),
				this.$absmartly.treatment('web_male_new_copy_3_plans'),
				this.$absmartly.treatment('web_new_copy_3_plans_eu'),
				this.$absmartly.treatment('web_new_copy_3_plans_latam')
			].some(Boolean)
		},
		IS_ZING_VIDEO_CONTENT_EXP() {
			// We don't want to show this experiment for already existing users
			// Because we need to set this flag for old user in this case
			if (this.user.id !== this.main_user_id) {
				return false
			}

			return [
				this.$absmartly.treatment('web_zing_video_content'),
				this.$absmartly.treatment('web_female_zing_video_content'),
				this.$absmartly.treatment('web_male_zing_video_content'),
				this.$absmartly.treatment('web_activity_zing_video_content')
			].some(Boolean)
		},
		IS_ASSESSMENT_CANCELLATION_EXP() {
			if (this.manageSubscriptionSource !== 'ios') {
				return false
			}

			return this.$absmartly.treatment('web_assessment_cancellation')
		},
		IS_CR_UPGRADES_INCREASE_EXP() {
			return [
				this.$absmartly.treatment('web_cr_upgrades_increase'),
				this.$absmartly.treatment('web_female_cr_upgrades_increase')
			].some(Boolean)
		},
		IS_PAYPAL_BY_DEFAULT_EXP() {
			return this.$absmartly.treatment('web_paypal_by_default')
		},
		IS_FEMALE_FUNNEL_HW_EXP() {
			return this.$absmartly.treatment('web_female_hw')
		},
		IS_PAUSE_SUBSCRIPTION_ON_CANCEL_EXP() {
			if (this.subscription?.store === 'palta') {
				return false
			}
			return this.$absmartly.treatment('web_pause_subscription_on_cancel')
		},
		IS_MALE_FUNNEL_ADDITIONAL_WEIGHT_PREDICT_EXP() {
			return this.$absmartly.treatment('web_male_additional_weight_predict')
		},
		IS_FEMALE_FUNNEL_ADDITIONAL_WEIGHT_PREDICT_EXP() {
			return this.$absmartly.treatment('web_female_additional_weight_predict')
		},
		IS_MAIN_FUNNEL_ADDITIONAL_WEIGHT_PREDICT_EXP() {
			return this.$absmartly.treatment('web_additional_weight_predict')
		},
		IS_PRIVACY_POLICY_CONSENT() {
			return this.$absmartly.treatment('web_privacy_policy_consent')
		}
	}
}
